// @ts-nocheck
import { addMessage, AddMessageApiParameter } from "@insite/client-framework/Services/MessageService";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { CartModel, MessageModel } from "@insite/client-framework/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cart: CartModel;
        message: string;
        onError?: (error: string) => void;
    } & HasOnSuccess,
    AddMessageApiParameter,
    MessageModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        customerOrderId: props.parameter.cart.id,
        message: props.parameter.message,
        toUserProfileName: props.parameter.cart.initiatedByUserName,
        subject: `Order ${props.parameter.cart.orderNumber} communication`,
        process: "OrderApproval",
    };
};

export const SendDataToApi: HandlerType = async props => {
    const result = await addMessage(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const DispatchLoadCart: HandlerType = props => {
    props.dispatch(
        loadCart({
            cartId: props.parameter.cart.id,
            apiParameter: {
                cartId: props.parameter.cart.id,
                additionalQueryStringParameters: {
                    rid: new Date().getTime().toString(),
                },
            },
        }),
    );
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, DispatchLoadCart, ExecuteOnSuccessCallback];

const sendMessage = createHandlerChainRunner(chain, "SendMessage");
export default sendMessage;
